import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { A5EventsEdit } from "./edit";
import { A5EventsNew } from "./new";
import { A5EventsTable } from "./table";

export default function A5Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5EventsEdit />} />
      <Route index element={<A5EventsTable />} />
      <Route path="/new" element={<A5EventsNew />} />
    </Routes>
  );
}
